<template>
  <div>
    <router-view :key="$route.fullPath"></router-view>
    <div class="row" v-if="$route.name === 'manage-surveys'">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-6">
                <h4 class="card-title" v-translate>Surveys</h4>
              </div>
              <div class="col-md-6 text-right">
                <router-link class="btn btn-success" :to="{name: 'manage-survey-add'}"><i class="nc-icon nc-simple-add"></i>&nbsp;<span v-translate>Add survey</span></router-link>
              </div>
            </div>
          </div>
          <paginated-table :table-data="[]" :remote-url="apiUrl" :per-page="10"
                           ref="table"
                           default-ordering="-id"
                           :search-fields="['name']">
            <template slot-scope="slot" slot="tableColumns">
                <el-table-column min-width="30" :label="'ID' | translate"
                                 sortable="custom" sort-by="id">
                  <template slot-scope="props">
                    <p>{{props.row.id}}</p>
                  </template>
                </el-table-column>
                <el-table-column
                                 sortable="custom" sort-by="name"
                                 :label="'Name' | translate">
                  <template slot-scope="props">
                    <p>{{props.row.name}}</p>
                  </template>
                </el-table-column>
                <el-table-column
                  class-name="action-buttons td-actions"
                  align="right"
                  :label="'Actions' | translate">
                  <template slot-scope="props">
                    <el-tooltip v-if="props.row.answersCount > 0" :content="'Export' | translate" placement="top">
                      <p-button type="info" size="sm" icon @click="(e) => handleExport(e, props.$index, props.row)">
                        <i class="fa fa-file-excel-o"></i>
                      </p-button>
                    </el-tooltip>
                    <el-tooltip :content="'Edit' | translate" placement="top">
                      <router-link :to="{name: 'manage-survey-edit', params: {id: props.row.id}}" tag="a"
                                   class="btn btn-icon btn-success btn-sm">
                        <i class="fa fa-edit"></i>
                      </router-link>
                    </el-tooltip>
                    <el-tooltip :content="'Delete' | translate" placement="top">
                      <p-button :disabled="props.row.answersCount > 0" type="danger" size="sm" icon @click="(e) => handleDelete(e, props.$index, props.row)">
                        <i class="fa fa-times"></i>
                      </p-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
            </template>
          </paginated-table>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Table, TableColumn, Tooltip} from 'element-ui'
  import PaginatedTable from 'src/components/Expostat/Components/PaginatedTable'
  import swal from 'sweetalert2'

  function b64DecodeUnicode (str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
  }


  export default {
    breadcrumb () {
      return {
        label: this.$gettext('Surveys'),
        parent: {name: 'manage-root'}
      }
    },
    computed: {
      apiUrl () {
        return 'survey/surveys/'
      }
    },
    components: {
      PaginatedTable,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Tooltip.name]: Tooltip
    },
    mounted () {
      this.$route.meta.title = this.$gettext('Surveys')
    },
    name: 'manage-surveys',
    methods: {
      selectBrand(row) {

      },
      handleDelete (event, index, row) {
        const vm = this
        event.stopPropagation()
        let message = this.$gettext('<span>Do you really want to remove the event <strong>%{name}</strong>?</span></br><span>It will be impossible to recover information!</span>')
        swal({
          title: this.$gettext('Are you sure?'),
          html: this.$gettextInterpolate(message, {name: row.name}),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$gettext('Yes, delete it!'),
          cancelButtonText: this.$gettext('No, keep it'),
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        }).then(function () {
          vm.$http.delete(`${this.apiUrl}${row.id}/`).then(result => {
            let message = vm.$gettext('<span>Event <strong>%{name}</strong> successfully deleted.</span>')
            swal({
              title: vm.$gettext('Successful delete'),
              html: vm.$gettextInterpolate(message, {name: row.name}),
              type: 'success',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            })
            vm.$refs.table.fetchData()
          }).catch(error => {
            let message = vm.$gettext('<span>Failed to delete event <strong>%{name}</strong><br>Status: %{statusCode}<br>Message: <code>%{details}</code></span>')
            let statusCode = error.response.status
            let details = ''
            if (error.response.data && error.response.data.detail) {
              details = error.response.data.detail
            }
            swal({
              title: vm.$gettext('Error'),
              html: vm.$gettextInterpolate(message, {name: row.name, statusCode, details}),
              type: 'error',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            })
          })
        }, function (dismiss) {
          // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
          // if (dismiss === 'cancel') {
          //   swal({
          //     title: 'Cancelled',
          //     text: 'Your imaginary file is safe :)',
          //     type: 'error',
          //     confirmButtonClass: 'btn btn-info btn-fill',
          //     buttonsStyling: false
          //   })
          // }
        })
      },
      async handleExport (event, index, row) {
        try {
          swal({
            title: this.$gettext('File formation'),
            html: this.$gettext('Please wait...'),
            onOpen: () => {
              swal.showLoading()
            }
          })
          const response = await this.$http.get(`${this.apiUrl}/${row.id}/answers/export/`, { responseType: 'blob' })
          swal.close()
          let filename = /=\?utf-8\?b\?(.+)\?=/.exec(response.headers.filename)
          if (filename !== null) {
            filename = b64DecodeUnicode(filename[1])
          } else {
            filename = response.headers.filename
          }
          if (!window.navigator.msSaveOrOpenBlob) {
            // BLOB NAVIGATOR
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
          } else {
            // BLOB FOR EXPLORER 11
            const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]), filename)
          }
        } catch (e) {
          console.error(e)
          let message = this.$gettext('An error occurred while generating the file. Try again later or contact technical support.')
          if (e.response && e.response.status === 403) {
            message = this.$gettext('Access denied!')
          }
          swal({
            type: 'error',
            title: this.$gettext('Error'),
            html: message
          })
        }

      }
    },
  }
</script>

<style scoped>

</style>
